export function clickMe(t) {
  window.open(`${t}`);
}